var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4.103 14.764.438 9.384c-.57-.8-.57-1.999 0-2.797l3.665-5.352C4.612.523 5.624 0 6.496 0h13.508C21.106 0 22 .897 22 1.996v12.008A1.998 1.998 0 0 1 20.004 16H6.496c-.874 0-1.884-.523-2.393-1.236Zm-2.05-6.978c-.074.103-.074.368 0 .47l3.677 5.346c.135.188.54.398.766.398H20V2H6.496c-.225 0-.631.21-.766.398L2.052 7.786ZM5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
  })));
};

export default SvgTag;